// services/DataCache.js
// Simple data cache service with localStorage persistence

class DataCache {
  constructor() {
    this.cache = new Map();
    this.loadFromStorage();
  }

  // Load cached data from localStorage
  loadFromStorage() {
    try {
      const saved = localStorage.getItem('app_data_cache');
      if (saved) {
        const parsed = JSON.parse(saved);
        Object.entries(parsed).forEach(([key, value]) => {
          this.cache.set(key, value);
        });
        console.log('[Cache] Loaded from localStorage:', this.cache.size, 'items');
      }
    } catch (error) {
      console.error('[Cache] Error loading from storage:', error);
    }
  }

  // Save cache to localStorage
  saveToStorage() {
    try {
      const obj = {};
      this.cache.forEach((value, key) => {
        obj[key] = value;
      });
      localStorage.setItem('app_data_cache', JSON.stringify(obj));
    } catch (error) {
      console.error('[Cache] Error saving to storage:', error);
    }
  }

  // Set cache data
  set(key, data) {
    this.cache.set(key, data);
    this.saveToStorage();
    console.log(`[Cache] Cached: ${key} (${Array.isArray(data) ? data.length : 'object'})`);
  }

  // Get cache data
  get(key) {
    return this.cache.get(key) || null;
  }

  // Check if cache exists
  has(key) {
    return this.cache.has(key);
  }

  // Clear specific cache
  clear(key) {
    if (key) {
      this.cache.delete(key);
    } else {
      this.cache.clear();
    }
    this.saveToStorage();
    console.log(`[Cache] Cleared: ${key || 'all'}`);
  }

  // Get cache stats
  getStats() {
    const stats = {};
    this.cache.forEach((value, key) => {
      stats[key] = Array.isArray(value) ? value.length : 'object';
    });
    return stats;
  }
}

// Create singleton instance
export const dataCache = new DataCache();

// Helper to get data with cache
export const getCachedData = (key, fetchFn) => {
  // Check cache first
  const cached = dataCache.get(key);
  if (cached) {
    console.log(`[Cache] Using cached data for: ${key}`);
    return Promise.resolve(cached);
  }

  // Fetch fresh data
  console.log(`[Cache] Fetching fresh data for: ${key}`);
  return fetchFn().then(data => {
    dataCache.set(key, data);
    return data;
  });
};